/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_SavedInputs */

const th_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกแล้ว`)
};

const en_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved.`)
};

const ja_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存しました。`)
};

const zh_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已保存。`)
};

const es_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado.`)
};

const pt_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvo.`)
};

const id_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersimpan.`)
};

const fr_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré.`)
};

const tl_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-save.`)
};

const vi_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu.`)
};

const ko_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장했습니다.`)
};

const de_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert.`)
};

const ru_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранено.`)
};

const tr_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydedildi.`)
};

const it_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvato.`)
};

const pl_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisano.`)
};

const uk_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Збережено.`)
};

const hi_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहेजा गया।`)
};

const ar_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الحفظ.`)
};

const ms_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disimpan.`)
};

const bn_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংরক্ষিত।`)
};

const zh_tw2_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已儲存。`)
};

const zh_hk2_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已儲存。`)
};

const ur_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محفوظ ہو گیا۔`)
};

const fa_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذخیره شد.`)
};

const sw_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imehifadhiwa.`)
};

const nl_event_saved = /** @type {(inputs: Event_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgeslagen.`)
};

/**
* | output |
* | --- |
* | "Saved." |
*
* @param {Event_SavedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_saved = /** @type {((inputs?: Event_SavedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_SavedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_saved(inputs)
	if (locale === "ja") return ja_event_saved(inputs)
	if (locale === "zh") return zh_event_saved(inputs)
	if (locale === "es") return es_event_saved(inputs)
	if (locale === "pt") return pt_event_saved(inputs)
	if (locale === "id") return id_event_saved(inputs)
	if (locale === "fr") return fr_event_saved(inputs)
	if (locale === "tl") return tl_event_saved(inputs)
	if (locale === "vi") return vi_event_saved(inputs)
	if (locale === "ko") return ko_event_saved(inputs)
	if (locale === "de") return de_event_saved(inputs)
	if (locale === "ru") return ru_event_saved(inputs)
	if (locale === "tr") return tr_event_saved(inputs)
	if (locale === "it") return it_event_saved(inputs)
	if (locale === "pl") return pl_event_saved(inputs)
	if (locale === "uk") return uk_event_saved(inputs)
	if (locale === "hi") return hi_event_saved(inputs)
	if (locale === "ar") return ar_event_saved(inputs)
	if (locale === "ms") return ms_event_saved(inputs)
	if (locale === "bn") return bn_event_saved(inputs)
	if (locale === "zh-TW") return zh_tw2_event_saved(inputs)
	if (locale === "zh-HK") return zh_hk2_event_saved(inputs)
	if (locale === "ur") return ur_event_saved(inputs)
	if (locale === "fa") return fa_event_saved(inputs)
	if (locale === "sw") return sw_event_saved(inputs)
	if (locale === "nl") return nl_event_saved(inputs)
	return en_event_saved(inputs)
});